// User role constants
export const ROLES = {
  SUPER_ADMIN: "5",
  ADMIN: "4",
  HEATING_USER: "3",
  LIMITED_CONTENT_USER: "6",
};

// Role groups for easier permission checking
export const ROLE_GROUPS = {
  ADMIN_ROLES: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
  ALL_ROLES: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.HEATING_USER],
};

// Helper function to check if user has admin access
export const isAdminRole = (role) => {
  return role === ROLES.SUPER_ADMIN || role === ROLES.ADMIN;
};

// Helper function to check if user is heating user
export const isHeatingUser = (role) => {
  return role === ROLES.HEATING_USER;
};

// Helper function to check if user is Super Admin (role 5)
export const isSuperAdmin = (role) => {
  return role === ROLES.SUPER_ADMIN;
};

// Helper function to check if user is Admin (role 4)
export const isAdmin = (role) => {
  return role === ROLES.ADMIN;
};

// Helper function to check if user is Limited Content User (role 6)
export const isLimitedContentUser = (role) => {
  return role === ROLES.LIMITED_CONTENT_USER;
};

// Helper function to check if user can manage other users (only Super Admin)
export const canManageUsers = (role) => {
  return role === ROLES.SUPER_ADMIN;
};

// Get default route for a role
export const getDefaultRoute = (role) => {
  if (isAdminRole(role)) {
    return "/home";
  }
  if (isHeatingUser(role)) {
    return "/heating-calc";
  }
  if (isLimitedContentUser(role)) {
    return "/home";
  }
  return "/login";
};
